// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SmartTextareaInput":"bfr_a bhc_vb bhc_vp bhc_xf bhc_vh"};